















































































import Vue from "vue";
import DashboardCard from "../../DashboardCard.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { state } from "../../data/state";
import { computed } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { ICONS } from "@/common/icons.map";
import { UseModal } from "@/components/root/modal";
import WhereDashboardModalVue from "@/views/overview/sources/ms-365-activities/mapping/where/WhereDashboardModal.vue";
import { AxisType } from "@/gql/types";
import EntitiesTableModalVue from "@/components/modals/entities-table-modal/EntitiesTableModal.vue";
import { get_modal_props } from "./modals.map";
import { PopulationTypeHelper } from "@/common/models";
export default Vue.extend({
  components: { DashboardCard, SkeletonLoaderItem },
  setup() {
    const {
      is_loading_all,
      information_shared_per_entity_per_label,
      selected_from_time_frame,
    } = state;
    const l0s = computed(() =>
      SharedState.l0InfoTypes.value
        .filter((f) => f.code !== 1)
        .map((d) => {
          return {
            id: d.id,
            name: d.labelName,
            icon: ICONS.L0_ICONS.get(d.code),
          };
        })
    );

    const show_entities_shares_modal = async () => {
      await UseModal().show(WhereDashboardModalVue);
    };

    const show_entities = async (
      label_id: string,
      entity_type: AxisType,
      desc: string
    ) => {
      console.log("show_events:", label_id, entity_type, desc);

      if (SharedState.restrictions.is_restricted_axis_type(entity_type)) {
        const entity_name = PopulationTypeHelper.asString(
          PopulationTypeHelper.fromAxisType(entity_type),
          true
        );
        SharedState.restrictions.show_restrictions_modal("entity", entity_name);
        return;
      }
      const { code, labelName } = SharedState.getInfoType(label_id)!;
      if (SharedState.restrictions.is_restricted_info(code)) {
        SharedState.restrictions.show_restrictions_modal("info", labelName);
        return;
      }

      const { type, value } = selected_from_time_frame.value!;
      const modal_props = get_modal_props(
        label_id,
        {
          type,
          values: [value],
        },
        entity_type
      );
      await UseModal().show(EntitiesTableModalVue, modal_props);
    };
    return {
      is_loading_all,
      show_entities,
      information_shared_per_entity_per_label,
      l0s,
      show_entities_shares_modal,
    };
  },
});
